module.exports = __webpack_public_path__ + "static/Cartovera-52d441af19dddcebf1b905356cc526f9.svg";